import { createContext, useContext } from "react";
import { Brands } from "@/types/pocketbase-types";

export type BrandContextType = {
  currentBrand: Brands | null;
  brands: Brands[];
  isLoading: boolean;
  error: Error | null;
  setCurrentBrand: (brand: Brands) => void;
  setBrands: (brands: Brands[]) => void;
  refreshBrands: () => Promise<void>;
};

export const BrandContext = createContext<BrandContextType | undefined>(
  undefined,
);

export const useBrand = () => {
  const context = useContext(BrandContext);

  if (context === undefined) {
    throw new Error("useBrand must be used within a BrandProvider");
  }

  return context;
};
